import React, { useState, useEffect } from 'react';
import "../AdminPanel.css";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';

const Vehicles = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [cars, setCars] = useState([]);
    const [filteredCars, setFilteredCars] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        // Get user data from localStorage
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        console.log(storedUserType); // Log to ensure it's retrieved correctly
        if (!storedUserType) {
            navigate("/login"); // Redirect if not logged in
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            // Combine first and last name if available
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    // Logout function
    const logout = () => {
        // Clear session data from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");

        // Redirect to login page after logout
        navigate("/login");
    };

    useEffect(() => {
        fetchCars();
    }, []);

    const fetchCars = async () => {
        try {
            const response = await axios.get('https://skcapi.btcjapan.co/fetch_cars.php');
            console.log('API Response:', response.data); // Debug the response
            // Ensure response.data is an array before setting state
            if (Array.isArray(response.data)) {
                setCars(response.data);
                setFilteredCars(response.data); // Initialize filteredCars with all cars
                setError(null);
            } else {
                console.error('API did not return an array:', response.data);
                setCars([]);
                setFilteredCars([]);
                setError(response.data.error || 'Failed to load vehicles: Invalid API response');
            }
        } catch (error) {
            console.error('Error fetching cars:', error);
            setCars([]);
            setFilteredCars([]);
            setError('Failed to load vehicles: Network or server error');
        }
    };

    // Handle search input change
    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        setCurrentPage(1); // Reset to first page on search

        if (term.trim() === "") {
            setFilteredCars(cars); // Show all cars if search term is empty
        } else {
            const filtered = cars.filter(car =>
                car.vin.toLowerCase().includes(term.toLowerCase())
            );
            setFilteredCars(filtered);
        }
    };

    const handleEdit = (id) => {
        navigate(`/edit-vehicle/${id}`);
    };

    const handleAllocate = (stock_id) => {
        navigate(`/allocate-vehicle/${stock_id}`);
    };

    const handleImageClick = (id) => {
        navigate(`/vehicle-images/${id}`);
    };

    const handleViewDocs = (id) => {
        navigate(`/view-docs/${id}`);
    };

    const handleDelete = async (id) => {
        try {
            // Confirm deletion with the user
            const confirmDelete = window.confirm('Are you sure you want to delete this car?');
            if (!confirmDelete) return;

            // Send a DELETE request to the backend
            const response = await axios.delete(`https://skcapi.btcjapan.co/delete_car.php?id=${id}`);

            // Log the response for debugging
            console.log('Delete response:', response.data);

            // Display a success message
            if (response.data.message) {
                alert(response.data.message); // Show success message
            } else if (response.data.error) {
                alert(response.data.error); // Show error message
            }

            // Refresh the car list after deletion
            fetchCars();
            // Reset to first page if the current page becomes empty
            const totalPages = Math.ceil(filteredCars.length / itemsPerPage);
            if (currentPage > totalPages && totalPages > 0) {
                setCurrentPage(totalPages);
            }
        } catch (error) {
            console.error('Error deleting car:', error);
            alert('An error occurred while deleting the car. Please check the console for details.');
        }
    };

    // Pagination logic
    const totalItems = filteredCars.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentCars = filteredCars.slice(startIndex, endIndex);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0); // Scroll to top on page change
    };

    // Get current date for comparison
    const currentDate = new Date();

    return (
        <div className="admin-container">
            <div className="sidebar-container">
              {userType === "administrator" && <SuperAdminSidebar />}
              {userType === "leader" && <LeaderSidebar />}
              {userType === "manager" && <ManagerSidebar />}
              {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                {/* Use the new AdminNavbar component */}
                <AdminNavbar pageTitle="Vehicles" />

                <div className="main-section">
                    <h3 className="section-title">View All Vehicles</h3>             

                    <div className="container">
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Chassis Number (VIN)"
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                        </div>
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>Image</th>
                                    <th style={{ textAlign: "center" }}>Stock ID</th>
                                    <th style={{ textAlign: "center" }}>Vehicle Details</th>
                                    <th style={{ textAlign: "center" }}>Chassis #</th>
                                    <th style={{ textAlign: "center" }}>Sold Price</th>
                                    <th style={{ textAlign: "center" }}>Allocated</th>
                                    <th style={{ textAlign: "center" }}>Balance</th>
                                    <th style={{ textAlign: "center" }}>Status</th>
                                    <th style={{ textAlign: "center" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentCars.length > 0 ? (
                                    currentCars.map((car) => (
                                        <tr key={car.id}>
                                            <td style={{ textAlign: "center" }}>
                                                <img
                                                    src={`https://skcapi.btcjapan.co/${car.images}`}
                                                    alt="Car"
                                                    style={{ width: '70px', height: 'auto', cursor: 'pointer' }}
                                                    onClick={() => handleImageClick(car.id)}
                                                />
                                            </td>
                                            <td style={{ textAlign: "center" }}>{car.stock_id}</td>
                                            <td style={{ textAlign: "center" }}>{car.maker} {car.model} {car.year}</td>
                                            <td style={{ textAlign: "center" }}>{car.vin}</td>
                                            <td style={{ textAlign: "right" }}>{car.sold_price}</td>
                                            <td style={{ textAlign: "right" }}>{parseFloat(car.allocated_amount).toFixed(2)}</td>
                                            <td style={{ textAlign: "right" }}>{car.sold_price - car.allocated_amount}</td>
                                            <td style={{ textAlign: "center" }}>
                                                {car.activationDate && new Date(car.activationDate) > currentDate ? 'Active' : 'Inactive'}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <span title="Edit">
                                                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEdit(car.id)} style={{ color: "#ffffff", marginRight: "10px", backgroundColor: "#0168FA", padding: "3px" }} width="20" height="20" alt="Edit" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                    </svg>
                                                </span>

                                                <span title="Delete">
                                                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDelete(car.id)} style={{ color: "#ffffff", marginRight: "10px", backgroundColor: "#DB2B2A", padding: "3px" }} width="20" height="20" alt="Delete" fill="currentColor" className="bi bi-archive" viewBox="0 0 16 16">
                                                        <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5zm13-3H1v2h14zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
                                                    </svg>
                                                </span>

                                                <span title="Allocate">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        onClick={() => handleAllocate(car.stock_id)}
                                                        style={{ color: "#ffffff", backgroundColor: "#0ab305ff", marginRight: "10px", padding: "1px" }}
                                                        width="20"
                                                        height="20"
                                                        fill="currentColor"
                                                        className="bi bi-cash"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                                                        <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2z" />
                                                    </svg>
                                                </span>

                                                <span title="PDF">
                                                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewDocs(car.id)} style={{ color: "#ffffff", backgroundColor: "#F29803", padding: "2px" }} width="20" height="20" fill="currentColor" className="bi bi-filetype-pdf" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z" />
                                                    </svg>
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
                                            {error ? 'Error loading vehicles' : searchTerm ? 'No vehicles found for this VIN' : 'No vehicles found'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Pagination Controls */}
                        {totalItems > itemsPerPage && (
                            <nav aria-label="Page navigation">
                                <ul className="pagination justify-content-center">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {[...Array(totalPages).keys()].map(page => (
                                        <li
                                            key={page + 1}
                                            className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(page + 1)}
                                            >
                                                {page + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>

                </div>

            </div>
        </div>
    );
};

export default Vehicles;